import { GetterTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { ISearchState } from './search-state.store';


export const getters: GetterTree<IRootState, ISearchState> = {
  activityStatus: (state: ISearchState) => state.activityStatus,
  status: (state: ISearchState) => state.status,
  service: (state: ISearchState) => state.service,
  contractors: (state: ISearchState) => state.contractors,
  declarants: (state: ISearchState) => state.declarants,
  managers: (state: ISearchState) => state.managers,
  caretakers: (state: ISearchState) => state.caretakers,
  salespersons: (state: ISearchState ) => state.salespersons,
  owners: (state: ISearchState ) => state.owners,
  independent_contractors: (state: ISearchState) => state.independent_contractors,
}


// WEBPACK FOOTER //
// ./src/store/search/search-getters.store.ts